require("./SummaryChecklist.less");

const React = require("react");

const QuestionType = require("~/types/Question.js").PropType;
const SummaryComment = require("../SummaryComment/SummaryComment.jsx");

const SummaryChecklist = React.createClass({
    propTypes: {
        Question: QuestionType.isRequired,
    },

    render() {
        const showCommentField = this.props.Question.AdditionalComment != "";
        const checklist = this.props.Question.AnswerOptions.map(this.MakeItem);

        const score = this.props.Question.MaxScore === 0
            ? ""
            : `${this.props.Question.Score}/${this.props.Question.MaxScore}`;

        return (<div className="cs-SummaryChecklist">
                <div className="cs-SummaryChecklist__Border">
                    <div className="cs-SummaryChecklist__Question"
                         dangerouslySetInnerHTML={{ __html: this.props.Question.DisplayHTML }}></div>
                    <ul className="cs-SummaryChecklist__list">{checklist}</ul>
                    <div className="cs-SummaryChecklist__Points">{score}</div>
                </div>
                <div className="cs-SummaryChecklist__Border">
                    {showCommentField && (
                    <SummaryComment Comment={this.props.Question.AdditionalComment} />)}
                </div>
        </div>);
    },

    MakeItem(answerOption) {
        const checked = this.IsSelected(answerOption.DisplayText);
        if (checked) {
            return (<li key={answerOption.GUID } className="cs-SummaryChecklist__checkbox">
                    <span>X - </span>
                    <span>{answerOption.DisplayText}</span>
            </li>);
        }
        else {
            return (<li key={answerOption.GUID } className="cs-SummaryChecklist__checkbox">
                    <span>_ - </span>
                    <span>{answerOption.DisplayText}</span>
            </li>);
        }

    },

    IsSelected(text) {
        if (this.props.Question.AnswerSelections
                .map((sel) => sel.SelectionText)
                .find((val) => val === text)) {
            return true;
        }

        return false;
    },

});

module.exports = SummaryChecklist;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SummaryChecklist/SummaryChecklist.jsx